import { defineQuery } from 'next-sanity'

export const careersBorderedTextBlockFields = `
  _id,
  _type,
  heading,
  introText,
  textBoxes[]{
    heading,
    mainText,
    borderColour
  },
  backgroundColor,
  variant
`

export const CAREERS_BORDERED_TEXT_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-bordered-text-block"][0]{
    ${careersBorderedTextBlockFields}
  }
`)
